import { render, staticRenderFns } from "./TabbedOnlineStore.vue?vue&type=template&id=60160318&scoped=true"
import script from "./TabbedOnlineStore.vue?vue&type=script&lang=js"
export * from "./TabbedOnlineStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60160318",
  null
  
)

export default component.exports